module.exports = __webpack_public_path__ + "static/media/SubmittedTen.4900a13e.png";